import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../../../common/types';
import { reelMessages } from './reelMessages';

/**
 * Design a6: the workspace cannot use AI reels (`canUseAiReels` is off, or a create answered 403
 * `M24_LIMIT_FEATURE`). The page shows this alert and no form.
 */
const ReelFeatureOffAlertComponent: React.FC = () => {
  const intl = useIntl();

  return (
    <Alert color="info" className="mb-0">
      <strong>{intl.formatMessage(reelMessages.featureOffTitle)}</strong>
      <br />
      {intl.formatMessage(reelMessages.featureOffBody)}
    </Alert>
  );
};

export const ReelFeatureOffAlert = TypedMemo(ReelFeatureOffAlertComponent);
